module.exports = "/packs/course-small-wordpress-3cb0adcf2b3ed088744ba9808cc8c571.png";